import React, { useState } from "react";

const AnimatePolvo = () => {
  return <div className="img-card sm:min-w-80 min-w-40 sm:min-h-80 min-h-40"></div>;
};

export default AnimatePolvo;
